module.exports = __webpack_public_path__ + "img/19.11.B.d093a8b6.png";